module.exports = __webpack_public_path__ + "img/EDC3200_1-1.780aecc1.png";